import React, { useRef, useState } from 'react';
import styles from './IndividualsCards.module.less';
import ReverseSearch from '@/components/leaked-private-photos/TopView/reverse-search';
import { useIsMobile } from '@/hooks/useIsMobile';
import { useTranslation } from 'next-i18next';
import ImageSearchContainer from '@/components/Content-Monitoring/Cpns/ImageSearchContainer';

const IndividualsCards: React.FC = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [isSearching, setIsSearching] = useState<boolean>(false);
  const [imageSearchUrl, setImageSearchUrl] = useState<string>('');
  const [isAgreePrivacy, setIsAgreePrivacy] = useState<boolean>(false);
  // eslint-disable-next-line
  const searchClickRef = useRef<((imageUrl: string) => void) | null>(null);
  const removeImageRef = useRef<(() => void) | null>(null);

  return (
    <div className={styles.cardGrid}>
      <ReverseSearch
        isSearching={isSearching}
        onSearchClick={(imageUrl: string) => searchClickRef.current?.(imageUrl)}
        imageSearchUrl={imageSearchUrl}
        setImageSearchUrl={setImageSearchUrl}
        onRegisterRemoveImage={(fn: () => void) => {
          removeImageRef.current = fn;
        }}
        reverseSearchTitle={t('Check If Your Photos Appear Online')}
        reverseSearchTitleFontSize={isMobile ? '20px' : '28px'}
        isAgreePrivacy={isAgreePrivacy}
        setIsAgreePrivacy={setIsAgreePrivacy}
        isInHomePage={true}
      />

      <div style={{ marginTop: '54px', padding: isMobile ? '0 5px' : '0' }}>
        <ImageSearchContainer
          isSearching={isSearching}
          setIsSearching={setIsSearching}
          onRegisterSearchClick={(fn) => {
            searchClickRef.current = fn;
          }}
          imageSearchUrl={imageSearchUrl}
          contentFunction="photo"
          setImageSearchUrl={setImageSearchUrl}
          onRemoveImage={() => removeImageRef.current?.()}
        />
      </div>
    </div>
  );
};

export default IndividualsCards;
